import React, { useEffect, useState } from 'react'
import { store } from '../../../redux/store';
import { Button, Input, Modal, Table, ConfigProvider, notification, Radio, Switch, Card } from 'antd';
import { PlusOutlined, DeleteOutlined, MinusOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import Serach from '../../generalComponent/search';
import { useNavigate } from 'react-router-dom';
//引入axios 进行服务器接口请求
import axios from "axios";
export default function Goods() {
  const [goodPacksOptions, setGoodPacksOptions] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, title, msg) => {
    api[type]({
      message: title,
      description: msg,
      placement: 'top',
      duration: 1
    });
  };

  const initialFields = { 'goodsName': '', 'category': '' };
  const initState = { 'id': '', 'goodsName': '', 'category': 1, 'status': 1, 'goodsName_isVisible': false, 'category_isVisible': false, 'packId': '' };
  const [state, setState] = useState(initState);
  const [dataSource, setDataSource] = useState([]);
  const [query, setQuery] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  useEffect(() => {
    queryList({});
  }, []); // 空数组确保只在挂载时设置观察者

  let navigate = useNavigate();

  const token = store.getState().uData.token;
  function queryList(data) {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/goods/list',
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataSource(response.data.data);
          setSelectedRowKeys([])
        } else {
          setDataSource({});
          setSelectedRowKeys([])
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };

  const [open, setOpen] = useState(false);

  //查询数据详情
  function modifyShowModal(id) {
    const params = new URLSearchParams();
    params.append('id', id);
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/goods/find',
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          queryGoodPacks();
          setState(response.data.data);
          setModalTitle("编辑货品信息")
          setOpen(true);
        } else {
          openNotificationWithIcon('error', '消息提示', '数据查询失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  const showModal = () => {
    queryGoodPacks();
    setState(initState);
    setModalTitle("新增货品信息")
    setOpen(true);
  };
  const handleOk = () => {
    handleAddOrModify();
  };
  const handleCancel = () => {
    setOpen(false);
  };

  //启用
  function handleBatchOpenAndClose(type) {
    const checkIds = selectedRowKeys;
    if (checkIds.length === 0) {
      openNotificationWithIcon('warning', '消息提示', '请先选择要启停的数据!')
      return;
    }
    const params = new URLSearchParams();
    params.append('ids', checkIds.join(","));
    //请求后台接口
    const url = type === 1 ? '/api/goods/open' : '/api/goods/close';
    const success_msg = type === 1 ? '数据启用成功！' : '数据停用成功！';
    const error_msg = type === 1 ? '数据启用失败！' : '数据停用失败！';
    axios.defaults.headers.common['token'] = token;
    axios.post(url,
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          const newSelectedRowKeys = [];
          for (let i = 0; i < selectedRowKeys.length; i++) {
            if (!checkIds.includes(selectedRowKeys[i])) {
              newSelectedRowKeys.push(selectedRowKeys[i]);
            }
          }
          setSelectedRowKeys(newSelectedRowKeys);
          queryList(query);
          openNotificationWithIcon('success', '消息提示', success_msg)
        } else {
          openNotificationWithIcon('error', '消息提示', error_msg)
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  function handleOpenAndClose(id, type) {
    if (id === "") {
      openNotificationWithIcon('warning', '消息提示', '请先选择要启停的数据!')
      return;
    }
    const params = new URLSearchParams();
    params.append('ids', id);
    //请求后台接口
    const url = type === 1 ? '/api/goods/open' : '/api/goods/close';
    const success_msg = type === 1 ? '数据启用成功！' : '数据停用成功！';
    const error_msg = type === 1 ? '数据启用失败！' : '数据停用失败！';

    axios.defaults.headers.common['token'] = token;
    axios.post(url,
      params
    ).then(
      response => {
        if (response.data.code === "200") {
          queryList(query);
          openNotificationWithIcon('success', '消息提示', success_msg)
        } else {
          openNotificationWithIcon('error', '消息提示', error_msg)
        }

      },
      error => {
        navigate("/error");
      }
    )
  }

  //添加或者修改
  function handleAddOrModify() {
    let valiad = true;
    //校验
    const { goodsName, category, id, status ,packId} = state;
    const items = [
      { name: 'goodsName', val: goodsName },
      { name: 'category', val: category }
    ];
    let success_msg = "";
    let error_msg = "";
    if (id) {
      success_msg = "数据修改成功！";
      error_msg = "数据修改失败！";
    } else {
      success_msg = "数据新增成功！";
      error_msg = "数据新增失败！";
    }

    items.map(item => {
      if (!item.val) {
        valiad = false;
        return setState(prevState => ({ ...prevState, [item.name + '_isVisible']: true }));
      }
      return null;
    })
    if (valiad) {
      const data = {
        id,
        goodsName,
        category,
        status,
        packId
      }
      //请求后台接口
      axios.post('/api/goods/addOrModify',
        data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      ).then(
        response => {
          if (response.data.code === "200") {
            openNotificationWithIcon('success', '消息提示', success_msg)
            queryList(query);
            setOpen(false);
          } else {
            openNotificationWithIcon('error', '消息提示', error_msg + response.data.msg)
            setOpen(true);
          }

        },
        error => {
          navigate("/error");
        }
      )
    } else {
      setOpen(true);
    }
  }
  //组装Serach组件的查询字段
  const searchFields = [
    {
      fieldName: 'goodsName',
      fieldCnName: '货品名称',
      placeholder: '请输入货品名称'
    }, {
      fieldName: 'category',
      fieldCnName: '货品类别',
      placeholder: '请选择货品类别',
      fieldType: 'select',
      optionData: [
        { value: 1, label: '蔬菜' },
        { value: 2, label: '干果' },
        { value: 3, label: '粮油' },
        { value: 4, label: '肉类' },
        { value: 5, label: '海鲜' },
        { value: 6, label: '水产' }
      ]
    }
  ]


  const handleSearch = (data) => {
    setQuery(data);
    queryList(data);
  };
  const inputChange = (event) => {
    if (!event.target.value) {
      setState({
        ...state,
        [event.target.name]: '',
        [event.target.name + '_isVisible']: true,
      })
    } else {
      setState({
        ...state,
        [event.target.name]: event.target.value,
        [event.target.name + '_isVisible']: false,
      })
    }
  }

  const columns = [
    {
      title: '货品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: '货品类别',
      dataIndex: 'category',
      key: 'category',
      fixed: 'left',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => {
        let name = "蔬菜";
        switch (record.category) {
          case 1:
            name = "蔬菜";
            break;
          case 2:
            name = "干果";
            break;
          case 3:
            name = "粮油";
            break;
          case 4:
            name = "肉类";
            break;
          case 5:
            name = "海鲜";
            break;
          case 6:
            name = "水产";
            break;
          default:
            break;
        }
        return <span>{name}</span>;
      }
    },
    {
      title: '使用状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <span style={record.status === 1 ? { color: '#68cf4f' } : { color: '#FF0000' }}>{record.status === 1 ? "启用" : "停用"}</span>
      )
    },
    {
      title: '操作',
      key: 'operation',
      align: 'center',
      responsive: ['lg'],
      render: (_, record) => (
        <div>
          <a onClick={() => modifyShowModal(record.id)} style={{ marginRight: '20px' }}>编辑</a>
          <a onClick={() => handleOpenAndClose(record.id, 1)} style={record.status === 1 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : { marginRight: '20px', color: '#68cf4f' }} >启用</a>
          <a onClick={() => handleOpenAndClose(record.id, 2)} style={record.status === 2 ? { marginRight: '20px', pointerEvents: 'none', opacity: '0.5', color: '#2F4F4F' } : { marginRight: '20px', color: '#FF0000' }}>停用</a>
        </div>
      )
    },
  ];

  const onGoodPackChange = (event) => {
      setState({
        ...state,
        [event.target.name]: event.target.value,
      })
  }  //查询所有启用状态的包装信息
  function queryGoodPacks() {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/pack/list',
      { status: 1 }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          const goodPackDatas = response.data.data;
          let goodPackDataArr = [];
          for (let i = 0; i < goodPackDatas.length; i++) {
            goodPackDataArr.push(
              { value: goodPackDatas[i].id, label: goodPackDatas[i].packName }
            )
          }
          setGoodPacksOptions(goodPackDataArr);
        } else {
          setGoodPacksOptions([]);
        }

      },
      error => {
        navigate("/error");
      }
    )
  }
  return (
    <React.Fragment>
      {contextHolder}
      <div className="item-location">
        当前所在位置 : 货品分类管理
      </div>

      <Serach fields={searchFields} initState={initialFields} onSearch={handleSearch} />

      <div className="data-div">
        <div className="bt_group">
          <Button onClick={showModal} className="bt_group_add"><PlusOutlined />新增</Button>
          <Button className="bt_group_batch_open" onClick={() => handleBatchOpenAndClose(1)}><DeleteOutlined />批量启用</Button>
          <Button className="bt_group_batch_close" onClick={() => handleBatchOpenAndClose(2)}><DeleteOutlined />批量停用</Button>
        </div>
        <ConfigProvider locale={zhCN}>
          <Table
            columns={columns}
            rowKey="id"
            dataSource={dataSource}
            rowSelection={rowSelection}
            bordered
            pagination={{ position: ['bottomCenter'], hideOnSinglePage: 'true' }}
            scroll={{ x: 1500 }}
            sticky={{ offsetHeader: 0 }}
          />
        </ConfigProvider>
      </div>

      <Modal
        open={open}
        title={modalTitle}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        centered={true}
        cancelText="取消"
        okText="确定"
        maskClosable={false}
      >
        <div>
          <div className="modal_field_style">
            <div className="modal_field_name_style">
              <span style={{ color: 'red' }}>*</span>
              <span>货品名称:</span>
            </div>
            <div style={{ width: '90%' }}><Input size="large" placeholder="请输入货品名称" name='goodsName' value={state.goodsName} onChange={inputChange} /></div>
          </div>
          <div className="modal_field_tip_style">
            <div style={{ width: '89%' }}><span className={state.goodsName_isVisible ? 'tip-msg-show' : 'tip-msg-hidden'}>请输入货品名称</span></div>
          </div>

          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>货品分类:</span>
            </div>
            <div style={{ width: '90%' }}>
              <Radio.Group name="category" value={state.category} onChange={inputChange}
                options={[
                  { value: 1, label: '蔬菜' },
                  { value: 2, label: '干果' },
                  { value: 3, label: '粮油' },
                  { value: 4, label: '肉类' },
                  { value: 5, label: '海鲜' },
                  { value: 6, label: '水产' }
                ]}
              />
            </div>
          </div>

          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>使用状态:</span>
            </div>
            <div style={{ width: '90%' }}>
              <Radio.Group name="status" value={state.status} onChange={inputChange}
                options={[
                  { value: 1, label: '启用' },
                  { value: 2, label: '停用' }
                ]}
              /></div>
          </div>
          <div className="modal_field_style_2">
            <div className="modal_field_name_style">
              <span>货品包装:</span>
            </div>
            <div style={{ width: '90%' }}>
              <Radio.Group options={goodPacksOptions} name="packId" value={state.packId} onChange={onGoodPackChange} />
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>

  )
}
